import React from 'react';
import { BsBehance, BsInstagram, BsLinkedin } from 'react-icons/bs';

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <BsInstagram />
    </div>
    <div>
      <BsBehance />
    </div>
    <div>
      <BsLinkedin />
    </div>
  </div>
);

export default SocialMedia;